import { AxiosAdapter, PackageAdapter } from '@adapters';
import { computed, ref, reactive } from 'vue';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
dayjs.extend(minMax);

import { PackageReservationListResponse } from '@dto';
import { cloneDeep } from 'lodash-es';
import { PackageReservationDetailResponse, TrResveMember } from '@core/dto';
export const usePackageReservationList = () => {
  const axiosAdapter = new AxiosAdapter();
  const packageAdapter = new PackageAdapter(axiosAdapter);
  const totalItems = computed(() => {
    return packageReservationListStatus.value?.total || 0;
  });
  const totalItemsPerPage = 10;
  const currentPage = ref<number>(1);
  const packageReservationListStatus = ref<PackageReservationListResponse>();
  const packageReservationStatusOrigin = ref<TrResveMember[]>();
  const packageReservationDetail = ref<PackageReservationDetailResponse | null>(
    null
  );
  const packageUseDate = computed(() => {
    const roomInfo = packageReservationDetail.value?.trResveStays;
    if (!roomInfo?.length) {
      return '';
    }
    const fromDate = roomInfo?.map((item) => dayjs(item.arrivalDate));
    const toDate = roomInfo?.map((item) => dayjs(item.departureDate));
    return `${dayjs.min(...fromDate)?.format('YYYY년MM월DD일')} ~ ${dayjs.max(...toDate)?.format('YYYY년MM월DD일')}`;
  });
  const packageCondoName = computed(() => {
    const roomInfo = packageReservationDetail.value?.trResveStays;
    const typeList = roomInfo?.map(({ roomType }) => roomType);
    return `상주 골프텔 ${[...new Set(typeList)].join(',')} 타입`;
  });
  const packageGolfReservationInfo = computed(() => {
    const date = packageReservationDetail.value?.resveDate;
    const golfInfo =
      packageReservationDetail.value?.trResveGroupMaps[0].tgResveConfirms;
    return golfInfo?.map((data) => {
      return {
        selfFlag: data.selfFlag,
        holeDiv: data.tgResveTime.holeDiv,
        resveCourse: data.tgResveTime.resveCourse,
        resveTime: data.tgResveTime.resveTime,
        resveDate: data.tgResveTime.resveDate,
        day: `${dayjs(data.tgResveTime.resveDate).diff(dayjs(date), 'day') + 1}일차`,
      };
    });
  });
  const params = reactive<{
    fromDate: string;
    toDate: string;
    limit: number;
    offset: number;
  }>({
    fromDate: '',
    toDate: '',
    limit: 0,
    offset: 0,
  });
  const searchParams = computed(() => {
    const fromDate = params.fromDate
      ? params.fromDate
      : dayjs().format('YYYY-MM-DD'); // 현재 날짜
    const toDate = params.toDate
      ? params.toDate
      : dayjs().add(3, 'month').format('YYYY-MM-DD'); // 3개월 후 날짜
    const limit = params.limit ? params.limit : totalItemsPerPage; // 페이지 당 항목 수
    const offset = params.offset
      ? params.offset
      : (currentPage.value - 1) * totalItemsPerPage; // 현재 페이지 오프셋
    return {
      fromDate,
      toDate,
      limit,
      offset,
    };
  });

  const fetchPackageReservationList = async () => {
    packageReservationListStatus.value =
      await packageAdapter.fetchPackageReservationList(searchParams.value);
    packageReservationStatusOrigin.value = cloneDeep(
      packageReservationListStatus.value?.trResveMembers
    );
  };

  const fetchPackageReservationDetail = async (payload: {
    rresveNo: number;
  }) => {
    packageReservationDetail.value =
      await packageAdapter.fetchPackageReservationDetail(payload);
  };

  const cancelPackageReservation = async (payload: { resveNo: number }) => {
    await packageAdapter.cancelPackageReservation(payload);
  };

  return {
    params,
    totalItems,
    totalItemsPerPage,
    currentPage,

    packageReservationListStatus,
    packageReservationStatusOrigin,
    packageReservationDetail,
    packageUseDate,
    packageCondoName,
    packageGolfReservationInfo,
    fetchPackageReservationList,
    fetchPackageReservationDetail,
    cancelPackageReservation,
  };
};
